import script from "./RedeemMGMPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RedeemMGMPage.vue?vue&type=script&setup=true&lang=ts"

import "./RedeemMGMPage.vue?vue&type=style&index=0&id=0192ffab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0192ffab"]])

export default __exports__